// @LTG-ID: F-005
// @STATUS: BUILT
// @HERMETIC: true
// @DOCS: 08_FEATURES.md#F-005, source Landing Page.html lines 1749-1759
// @CHANGED: 2026-02 session_002
// @OWNER: web

import { DEFAULT_CITATION } from "../../data/sectors";
import { useSector } from "../../lib/use-sector";
import "./citation-strip.css";

export function CitationStrip() {
    const { sectorRecord } = useSector();
    const cite = sectorRecord ? sectorRecord.citation : DEFAULT_CITATION;
    return (
        <div className="ltg-citation" data-testid="citation-strip">
            <div className="ltg-container ltg-citation__inner">
                <span className="ltg-citation__label">Calibrated against</span>
                <span
                    className="ltg-citation__sources"
                    data-testid="citation-text"
                >
                    {cite}
                </span>
            </div>
        </div>
    );
}

export default CitationStrip;
